import bridge from '@/lib/bridge';
import vHistory from '@/lib/history';
import { useObserver } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import VCopyRight from './v-copyright';
import VNav from './v-nav';

interface IProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  reserved?: string;
}

const VScreen = (props: IProps) => {
  const { ref, children, ...rest } = props;

  return useObserver(() => (
    <Wrapper className="v-screen" ifShowNav={vHistory.ifShowNav()} {...rest}>
      <div className="v-screen__mask">
        <div className="v-screen__footer">
          <VCopyRight />
        </div>
      </div>
      <div className="v-screen__body">
        {/* {(bridge.isWebView() || vHistory.ifShowNav()) && <VNav className="v-screen__nav" />} */}
        {vHistory.ifShowNav() && <VNav className="v-screen__nav" />}
        <div className="v-screen__content">{children}</div>
      </div>
    </Wrapper>
  ));
};

export default VScreen;

const Wrapper = styled.div<{ ifShowNav: boolean }>`
  display: relative;
  /* width: 100vw;
  height: 100vh; */
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  min-width: 300px;
  .v-screen {
    &__mask {
      position: fixed;
      z-index: -1;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(1, 1, 1, 0.5);
    }
    &__body {
      position: relative;
      width: 80%;
      /* height: 70vh; */
      height: 70%;
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      border-radius: 8px;
      overflow: hidden;
    }
    &__content {
      position: relative;
      overflow-y: auto;
      flex: 1;
      background-color: #ffffff;
      & > div:first-child {
        padding: ${(props) =>
          props.ifShowNav
            ? 0
            : `${props.theme.paddingTop / props.theme.density}px 0
          ${props.theme.paddingBottom / props.theme.density}px 0`};
      }
      /* min-height: 440px; */
    }
    &__footer {
      color: #fff;
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  @media only screen and (max-width: ${(props) => `${props.theme.mobileWidth}px`}) {
    .v-screen {
      &__mask {
        display: none;
      }
      &__body {
        width: 100%;
        /* height: 100vh; */
        height: 100%;
        border-radius: 0;
      }
      &__content {
        background-color: ${(props) => props.theme.mobileBgColor};
      }
    }
  }
`;
